var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareersInclusiveCulture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2976 18.944V7.224C28.2976 5.444 26.8536 4 25.0736 4C23.2936 4 21.8516 5.444 21.8516 7.224V16.892",
    stroke: "url(#paint0_linear_1235_8191)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.692 25.6811L37.044 11.1771C37.165 10.7749 37.2049 10.3526 37.1613 9.93489C37.1176 9.51714 36.9914 9.11223 36.7898 8.74373C36.5883 8.37523 36.3154 8.05049 35.9872 7.7884C35.659 7.52631 35.2819 7.33211 34.878 7.21709C34.4763 7.1026 34.0559 7.06864 33.641 7.11715C33.2261 7.16567 32.8249 7.29569 32.4605 7.49976C32.096 7.70383 31.7755 7.97792 31.5173 8.30628C31.2591 8.63463 31.0683 9.01077 30.956 9.41309L28.296 18.9411M15.24 18.4991L17.35 23.1811C17.6761 23.9561 17.6865 24.828 17.3789 25.6106C17.0714 26.3932 16.4703 27.0247 15.7037 27.3704C14.9372 27.7161 14.0659 27.7486 13.2758 27.461C12.4856 27.1735 11.839 26.5886 11.474 25.8311L9.35998 21.1491C9.18598 20.763 9.08972 20.3464 9.07672 19.9231C9.06371 19.4999 9.1342 19.0782 9.28417 18.6821C9.58704 17.8823 10.1952 17.2355 10.975 16.8841C11.7547 16.5327 12.6421 16.5054 13.442 16.8083C14.2418 17.1111 14.8886 17.7193 15.24 18.4991Z",
    stroke: "url(#paint1_linear_1235_8191)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4396 24.5215C23.8485 23.3866 23.7997 22.1371 23.3036 21.0375L21.1576 16.2775C20.9861 15.8973 20.7412 15.5547 20.437 15.2694C20.1327 14.9841 19.7752 14.7616 19.3847 14.6148C18.9943 14.468 18.5788 14.3997 18.1619 14.4139C17.7451 14.4281 17.3351 14.5245 16.9556 14.6975C16.5701 14.8734 16.2238 15.1249 15.9371 15.437C15.6505 15.7491 15.4294 16.1155 15.287 16.5146C15.1445 16.9137 15.0835 17.3373 15.1077 17.7603C15.1318 18.1834 15.2406 18.5973 15.4276 18.9775L15.6976 19.5295",
    stroke: "url(#paint2_linear_1235_8191)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7139 35.3531L28.6979 33.3851C28.7211 33.339 28.7338 33.2883 28.7353 33.2367C28.7367 33.1851 28.7267 33.1338 28.7061 33.0865C28.6855 33.0392 28.6547 32.9969 28.616 32.9628C28.5772 32.9287 28.5315 32.9035 28.4819 32.8891L21.3819 30.8011C20.692 30.5982 20.0951 30.16 19.695 29.5625C19.2949 28.9651 19.1168 28.2462 19.1919 27.5311C19.2763 26.7269 19.6742 25.9883 20.2994 25.4754C20.9246 24.9626 21.7267 24.7167 22.5319 24.7911L32.1079 25.6831C32.1079 25.6831 39.7279 26.8551 37.0879 34.4731C34.4519 42.0931 33.5739 44.7291 27.7139 44.7291H17.7519C15.4981 44.7291 13.3366 43.8338 11.7429 42.2401C10.1492 40.6464 9.25391 38.4849 9.25391 36.2311V21.9512",
    stroke: "url(#paint3_linear_1235_8191)",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1235_8191",
    x1: 13.0107,
    y1: 7.41319,
    x2: 34.9141,
    y2: 46.6215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1235_8191",
    x1: 9.74329,
    y1: 7.0957,
    x2: 33.4619,
    y2: 44.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1235_8191",
    x1: 8.77518,
    y1: 6.56609,
    x2: 34.43,
    y2: 45.6534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1235_8191",
    x1: 6.35492,
    y1: 8.98636,
    x2: 37.6436,
    y2: 47.4686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareersInclusiveCulture);
export default __webpack_public_path__ + "static/media/Careers_Inclusive_Culture.eb02440cd248ca6ded8145098157234f.svg";
export { ForwardRef as ReactComponent };